import { Component, OnInit } from '@angular/core';
import { TasksServices } from '../tasks-services';
import { TaskDetails } from '../../models/task-details';
import { Task } from '../../models/task';

@Component({
  selector: 'app-all-tasks',
  templateUrl: './all-tasks.component.html',
  styleUrls: ['./all-tasks.component.css']
})
export class AllTasksComponent implements OnInit {
  tasksListDetail: TaskDetails[];

  constructor(private taskService: TasksServices) {
     this.tasksListDetail = taskService.getAllTasks();
   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/tasks/all-tasks/all-tasks.component.ts